import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IdleReloadServiceService implements OnDestroy {

  /**
   * Umbral de inactividad en milisegundos (por defecto 5 minutos)
   */
  private _inactivityThreshold = 5 * 60 * 1000;
  
  /**
   * Timestamp cuando la pestaña fue ocultada
   */
  private _hiddenTimestamp: number | null = null;
  
  /**
   * Referencia al listener del evento de visibilidad
   */
  private _visibilityListener: () => void;

  constructor() { }

  /**
   * Inicia la escucha del evento visibilitychange.
   * @param thresholdMinutes Tiempo en minutos para considerar la pestaña como inactiva
   */
  start(thresholdMinutes?: number): void {
    if (thresholdMinutes) {
      this._inactivityThreshold = thresholdMinutes * 60 * 1000;
    }

    this._visibilityListener = this._onVisibilityChange.bind(this);
    document.addEventListener('visibilitychange', this._visibilityListener);
  }

  /**
   * Maneja el cambio de visibilidad de la pestaña
   */
  private _onVisibilityChange(): void {
    if (document.visibilityState === 'hidden') {
      this._hiddenTimestamp = Date.now();
    } else if (document.visibilityState === 'visible') {
      if (this._hiddenTimestamp) {
        const inactiveTime = Date.now() - this._hiddenTimestamp;
        this._hiddenTimestamp = null;

        if (inactiveTime >= this._inactivityThreshold) {
          window.location.reload();
        }
      }
    }
  }

  /**
   * Detiene la escucha del evento visibilitychange
   */
  stop(): void {
    if (this._visibilityListener) {
      document.removeEventListener('visibilitychange', this._visibilityListener);
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
